export enum DateFormats {
  DEFAULT = 'YYYY-MM-DD',
  YEAR_MONTH = 'YYYY-MM',
  DEFAULT_PRESENTATION = 'DD/MM/YYYY',
  YEAR_MONTH_PRESENTATION = 'MM/YYYY',
  REVERSED_DEFAULT = 'DD-MM-YYYY',
  TIME = 'HH:mm:ss',
  NO_SPLIT = 'YYYYMMDD',
  TIME_DOT = 'HH.mm',
  DEFAULT_PRESENTATION_DOT = 'DD.MM.YYYY',
  DEFAULT_PRESENTATION_DOT_WITH_TIME = 'HH:mm DD.MM.YYYY',
  NORMAL_DATE = 'YYYY-MM-DD HH:mm:ss',
  DEFAULT_PRESENTATION_SHORT_MONTH = 'DD MMM YYYY',
}

export const MAX_DATE = '2099-01-01';
